import React from 'react';
import { XIcon } from 'lucide-react';
import { painPoints } from '../data/content';
export function PainPoints() {
  return <section aria-labelledby="problema" className="border-y border-ink-600 bg-ink-800" data-id="element-157" data-mp="2lm0tl8tup4sz">
      <div className="mx-auto max-w-5xl px-5 py-16 sm:py-20" style={{
      paddingTop: "17px",
      paddingBottom: "16px"
    }} data-id="element-158" data-mp="26xeftbjvgl3v">
        <h2 id="problema" className="text-center font-display text-3xl uppercase leading-tight text-white sm:text-4xl" data-id="element-159" data-mp="2bvodbst2jxsn">
          ¿Cuántos fines de semana más
          <span className="block text-court-400" data-id="element-160" data-mp="21zl8gf6u1l20">vas a perder así?</span>
        </h2>

        <p className="mx-auto mt-6 max-w-2xl text-center text-base leading-relaxed text-slate-300 sm:text-lg" data-id="element-161" data-mp="1o03gjqy8prof">
          Amas el pádel, pero tu tiempo libre lo gastas preparando sesiones a cualquier hora.
          <strong className="font-semibold text-white" data-id="element-162" data-mp="3idbgfx12otgx"> No es falta de vocación. Es falta de un sistema.</strong>
        </p>

        <p className="mt-10 text-center text-sm font-bold uppercase tracking-[0.2em] text-slate-500" data-id="element-163" data-mp="3nbd12me5d0ui">
          ¿Te suena familiar alguna de estas situaciones?
        </p>

        <ul className="mx-auto mt-6 max-w-3xl divide-y divide-ink-600 border-y border-ink-600" data-id="element-164" data-mp="1u2dieffw1gxj">
          {painPoints.map(point => <li key={point} className="flex gap-4 py-4" data-id="element-165" data-mp="27rp2tdukugo9">
              <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-400" aria-hidden="true" data-id="element-166" data-mp="23rnb9xik33mp" />
              <span className="text-[15px] leading-relaxed text-slate-300" data-id="element-167" data-mp="1g1t0dlhsrp53">{point}</span>
            </li>)}
        </ul>

        
      </div>
    </section>;
}